import { render, staticRenderFns } from "./EmployeeInboxNotesModal.vue?vue&type=template&id=1b19001a&"
import script from "./EmployeeInboxNotesModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeInboxNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeInboxNotesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports